export function accordion() {
  const buttons = document.querySelectorAll('.p-top-partner__toggle');

  // トップページのパートナーのアコーディオン
  buttons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.stopPropagation(); // イベントのバブリングを防ぐ

      const currentListItems = this.parentElement.querySelectorAll('.p-top-partner__item');
      const isOpen = Array.from(currentListItems).some(item => item.classList.contains('p-top-partner__item--open'));

      closeAllAccordions();

      if (!isOpen) {
        currentListItems.forEach(item => {
          item.classList.add('p-top-partner__item--open');
          requestAnimationFrame(() => {
            item.style.maxHeight = item.scrollHeight + 'px';
            item.style.opacity = '1';
          });
          button.classList.add('is-open');
        });
      }
    });
  });

  // アコーディオンの外側をクリックしたら閉じる
  document.addEventListener('click', function(event) {
    if (!Array.from(buttons).some(button => button.contains(event.target))) {
      closeAllAccordions();
    }
  });

  function closeAllAccordions() {
    const allListItems = document.querySelectorAll('.p-top-partner__item--open');
    allListItems.forEach(item => {
      item.style.maxHeight = '0';
      item.style.opacity = '0';
      setTimeout(() => {
        item.classList.remove('p-top-partner__item--open');
      }, 400);
    });

    buttons.forEach(button => {
      button.classList.remove('is-open');
    });
  }
}
